import type { SVGProps } from 'react';
export const IconSocialsOk = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.333 11.1614C21.333 14.0066 18.9357 16.3211 15.9864 16.3211C13.0379 16.3211 10.6399 14.0066 10.6399 11.1614C10.6399 8.31509 13.0379 6 15.9864 6C18.9357 6 21.333 8.31509 21.333 11.1614ZM18.1633 20.5336C19.2517 20.2943 20.3013 19.8786 21.268 19.2925C21.9997 18.8473 22.22 17.9137 21.759 17.2075C21.2984 16.4997 20.332 16.2866 19.599 16.7319C17.409 18.0614 14.5893 18.061 12.4005 16.7319C11.6676 16.2866 10.7009 16.4997 10.2411 17.2075C9.78015 17.9144 9.9999 18.8473 10.7315 19.2925C11.6983 19.878 12.7479 20.2943 13.8363 20.5336L10.847 23.419C10.236 24.0095 10.236 24.9668 10.8476 25.5571C11.1539 25.8521 11.5544 25.9998 11.9549 25.9998C12.356 25.9998 12.7573 25.8521 13.0634 25.5571L15.9995 22.7217L18.9382 25.5571C19.5492 26.1476 20.5405 26.1476 21.1523 25.5571C21.7645 24.9668 21.7645 24.0089 21.1523 23.419L18.1633 20.5336ZM18.2 11.1614C18.2 9.983 17.207 9.02475 15.9863 9.02475C14.7665 9.02475 13.7725 9.983 13.7725 11.1614C13.7725 12.3389 14.7665 13.2976 15.9863 13.2976C17.207 13.2976 18.2 12.3389 18.2 11.1614Z"
      fill="currentColor"
    />
  </svg>
);
